import { Formik } from 'formik';
import { Ref } from 'react';

import { EnergyDetailsFormValues } from '@src/types/energy';

import { Form } from './Form';
import { validateForm } from './validateForm';

interface EnergyQuoteFormProps {
  initialValues: EnergyDetailsFormValues;
  isLoading: boolean;
  onSubmit: (values: EnergyDetailsFormValues) => void;
  onValidated: (valid: boolean) => void;
  ref?: Ref<HTMLFormElement>;
}

const EnergyForm = ({
  onSubmit,
  onValidated,
  initialValues,
  isLoading,
  ref,
}: EnergyQuoteFormProps) => {
  return (
    <Formik
      validateOnMount
      initialValues={initialValues}
      validate={validateForm}
      onSubmit={onSubmit}
    >
      <Form ref={ref} onValidated={onValidated} isLoading={isLoading} />
    </Formik>
  );
};

export { EnergyForm };
